import { PreviewProps } from './Types'
import Styles from './SuggestedCategory.module.scss'

export const Preview = ({ alt, src }: PreviewProps) => (
  <div className={Styles.preview}>
    <img src={src} alt={alt} />
  </div>
)
